import {ErrorMessage, Field, Form, Formik} from "formik";
import * as Yup from "yup";
import {DeleteOutline, Edit, NavigateBefore, NavigateNext, Schedule} from "@mui/icons-material";
import React, {useEffect, useState} from "react";
import {
    getCertificates, getCitylist,
    getNews,
    getParcel,
    getPostcenterslist,
    getProducts,
    getProviences,
    url
} from "../services/service";
import axios from "axios";
import {toast} from "react-toastify";

import {useNavigate} from "react-router-dom";
import {Spinner, BlogsTable} from "../components";

import AlertDialog from "../components/extras/Modal";
import EditPostCenterModal from "../components/extras/EditPostCenterModal";
import {useSelector} from "react-redux";
import {userinfoSelector} from "../slices/UserSlice";


const Products = () => {

    const dataneeded = useSelector(userinfoSelector)
    const [data, setData] = useState(false)



    const [provience, setProvience] = useState(false)
    const [selectedProvince, setSelectedProvince] = useState(false)


    const nav = useNavigate()


    // pending
    const [pending, setPending] = useState(false)


    // getting proviences list

    const getProvienceslist = async () => {

        const response = await getProviences()
        if (response && response.data.code == 1) {
            setProvience(response.data.provinces)

        } else {
            toast.error(response.data.message)
        }
    }


    // getting city for selected province

    const [citylist, setCitylist] = useState(false)
    const [selectedCity, setSelectedCity] = useState(false)

    const getCity = async () => {


        const config = {
            params: {
                province_id: selectedProvince
            }
        }
        const response = await getCitylist(config)
        if (response && response.data.code == 1) {
            setCitylist(response.data.provinces)
        } else {
            toast.error(response.data.message)
        }


    }

    useEffect(() => {
        getCity()
    }, [selectedProvince])


    const getData = async (page) => {
        const token = JSON.parse(localStorage.getItem('admin'))
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params: {
                take: 10, page: page,
            }
        }
        const response = await getPostcenterslist(config)

        if (response) {
            setData(response.data)

        }

    }


    useEffect(() => {


        getProvienceslist().then()


    }, []);


    const handleAdd = async (values) => {
        const token = JSON.parse(localStorage.getItem('admin'))
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
        const conf = window.confirm('آیا  مطمن هستید ؟')
        if (conf) {
            const endpoint = `${url}/postcenter/parcel/create`


            const formdata = new FormData()
            formdata.append("sender_phone", values.stel)
            formdata.append("sender_name", values.sname)
            formdata.append("receiver_name", values.rname)
            formdata.append("receiver_phone", values.rtel)
            formdata.append("address", values.address)
            formdata.append("weight", values.weight)
            formdata.append("price", values.price)
            formdata.append("send_city_id", selectedCity)

            formdata.append("receive_city_id",selectedCity)
            formdata.append("notes",values.description)




            toast.info('در حال ارسال ...')
            const response = await axios.post(endpoint, formdata, config)
            if (response) {
                toast.dismiss()
                if (response.data.code === 1) {

                    toast.success('با موفقیت اضافه شد.');
                    setPending(false)

                    getData().then();
                } else {
                    toast.warning(response.data.error)
                }
            } else {
                toast.error('اتصال خود را بررسی کنید')
            }


        }

    }





    // let content
    // if (data !== false) {
    //     content =
    //         <>
    //
    //
    //             <BlogsTable>
    //
    //                 {data.items.map((item) => {
    //
    //                     return (
    //                         <>
    //                             <tr key={item.postcenters.id} className='has-text-centered yekan'>
    //
    //                                 <td>{item.postcenters.name}</td>
    //                                 <td>{item.provinces.name}</td>
    //                                 <td>{item.cities.name}</td>
    //                                 <td>{item.postcenters.address}</td>
    //                                 <td>{item.postcenters.tel}</td>
    //                                 <td>
    //                                     <AlertDialog center={item.postcenters.name} name={item.postcenters.username}
    //                                                  pw={item.postcenters.password}/>
    //                                 </td>
    //
    //                                 <td>
    //                                 <EditPostCenterModal info={item}/>
    //                                 </td>
    //
    //
    //                             </tr>
    //                         </>
    //
    //                     )
    //                 })}
    //             </BlogsTable>
    //
    //             <div className='column is-12'>
    //                 {data &&
    //                     <div className='pinar' style={{display: 'flex', justifyContent: 'center'}}>
    //
    //
    //                         {/*before page with tick*/}
    //                         {
    //                             data.paginator.beforePage < data.paginator.currentPage && (
    //
    //                                 <button onClick={() => getData(data.paginator.beforePage)} className='button'>
    //                                     <NavigateNext/>
    //                                 </button>
    //                             )
    //
    //
    //                         }
    //
    //
    //                         {/*map beforePages*/}
    //                         {data.paginator.beforePages.length > 0 &&
    //
    //                             <>
    //                                 {data.paginator.beforePages.map((item, index) =>
    //                                     <button className='button' onClick={() => getData(item)} key={index}>
    //                                         {item}
    //                                     </button>
    //                                 )}
    //                             </>
    //
    //                         }
    //
    //
    //                         {/*active*/}
    //
    //                         {
    //                             data.paginator.total > 0 &&
    //                             <button
    //                                 className='clrtwo has-text-white button'>{data.paginator.currentPage}</button>
    //
    //
    //                         }
    //
    //
    //                         {/*map nextPages*/}
    //                         {data.paginator.nextPages.length > 0 &&
    //                             <>
    //                                 {data.paginator.nextPages.map((item, index) =>
    //                                     <button className='button' onClick={() => getData(item)} key={index}>
    //                                         {item}
    //                                     </button>
    //                                 )}
    //                             </>
    //
    //                         }
    //
    //
    //                         {/*next page with tick*/}
    //                         {
    //
    //                             data.paginator.nextPage > data.paginator.currentPage && (
    //
    //                                 <button onClick={() => getData(data.paginator.nextPage)}
    //                                         className='button is-transparent'>
    //                                     <NavigateBefore/>
    //                                 </button>
    //                             )
    //
    //
    //                         }
    //
    //
    //                     </div>
    //                 }
    //             </div>
    //
    //
    //         </>
    // } else {
    //     content = <div className='column is-12'>
    //         <Spinner/>
    //     </div>
    // }
    return (
        <>
            <div className='columns is-variable is-3  p-5  is-multiline '>
                <div className='column is-12 welcome__master '>
                    <h1 className='has-text-centered pinar is-size-4 clrtwotext has-text-weight-bold'>
                       بسته جدید


                    </h1>

                    <article className='subtitle yekan my-3 is-size-6'>
                        ثبت بسته جدیدد در این قسمت صورت میگیرد.
                    </article>

                </div>


                <div className='column is-12 welcome__master my-2'>


                    <h3 className='yekan'>
                        اضافه کردن بسته
                    </h3>


                    <Formik initialValues={{
                        rname: '',
                        rtel: '',
                        sname: '',
                        stel: '',
                        address: '',
                        weight:'',
                        price:'',
                        description:''


                    }}  onSubmit={(values, actions) => {
                        handleAdd(values);
                        actions.resetForm();
                    }}>
                        {({errors, touched}) => (
                            <Form className=''>

                                <div className='columns is-multiline'>


                                    <div className='column is-6'>
                                        <label className='label mt-3 yekan'>انتخاب استان مقصد</label>
                                        <Field className='select yekan width100' as="select" value={selectedProvince}
                                               onChange={(e) => {
                                                   setCitylist(false)
                                                   setSelectedProvince(e.target.value);
                                               }}>
                                            <option disabled label="انتخاب کنید"/>

                                            {
                                                provience == false ?
                                                    <>
                                                        <Spinner/>
                                                    </>
                                                    :
                                                    provience.map((item) => (
                                                        <option key={item.id} value={item.id}>{item.name}</option>
                                                    ))
                                            }
                                        </Field>

                                    </div>

                                    <div className='column is-6'>
                                        <label className='label mt-3 yekan'>انتخاب شهر مقصد</label>
                                        <Field disabled={selectedProvince == false} className='select yekan width100'
                                               as="select" value={selectedCity}
                                               onChange={(e) => {
                                                   setSelectedCity(e.target.value);
                                               }}>
                                            <option disabled label="انتخاب کنید"/>

                                            {
                                                citylist == false ?
                                                    <>
                                                        <Spinner/>
                                                    </>
                                                    :
                                                    citylist.map((item) => (
                                                        <option key={item.id} value={item.id}>{item.name}</option>
                                                    ))
                                            }
                                        </Field>

                                    </div>

                                    <div className='column is-6'>
                                        <label className='label mt-3 yekan' aria-hidden="true">نام دریافت کننده </label>
                                        <Field className='yekan input my-2' type="text" id="rname" name="rname"/>
                                        <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                      name='rname'/>
                                    </div>

                                    <div className='column is-6'>
                                        <label className='label mt-3 yekan' aria-hidden="true">تلفن دریافت
                                            کننده </label>
                                        <Field className='yekan input my-2' type="tel" id="rtel" name="rtel"/>
                                        <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                      name='rtel'/>
                                    </div>

                                    <div className='column is-6'>
                                        <label className='label mt-3 yekan' aria-hidden="true">نام فرستنده </label>
                                        <Field className='yekan input my-2' type="text" id="sname" name="sname"/>
                                        <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                      name='sname'/>
                                    </div>

                                    <div className='column is-6'>
                                        <label className='label mt-3 yekan' aria-hidden="true">تلفن فرستنده
                                             </label>
                                        <Field className='yekan input my-2' type="tel" id="stel" name="stel"/>
                                        <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                      name='stel'/>
                                    </div>


                                    <div className='column is-12'>
                                        <label className='label mt-3 yekan' aria-hidden="true">آدرس تحویل </label>
                                        <Field className='yekan input my-2' type="text" id="address" name="address"/>
                                        <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                      name='address'/>
                                    </div>


                                    <div className='column is-6'>
                                        <label className='label mt-3 yekan' aria-hidden="true"> وزن بسته (گرم) </label>
                                        <Field className='yekan input my-2' type="number" id="weight" name="weight"/>
                                        <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                      name='weight'/>
                                    </div>

                                    <div className='column is-6'>
                                        <label className='label mt-3 yekan' aria-hidden="true">هزینه (تومان)
                                        </label>
                                        <Field className='yekan input my-2' type="number" id="price" name="price"/>
                                        <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                      name='price'/>
                                    </div>

                                    <div className='column is-12'>
                                        <label className='label mt-3 yekan' aria-hidden="true">توضیحات
                                        </label>
                                        <Field className='yekan input my-2' type="text" id="description" name="description"/>
                                        <ErrorMessage component='span' className='has-text-danger yekan mx-auto'
                                                      name='description'/>
                                    </div>


                                </div>


                                <div className='has-text-centered py-6'>
                                    {
                                        pending ? <Spinner/> : <button
                                            className='button clrtwo has-text-white has-text-weight-bold  pinar mt-6 mx-3 borderrad1 '
                                            type='submit'> اضافه کن
                                        </button>
                                    }


                                </div>


                            </Form>


                        )}


                    </Formik>
                </div>


            </div>


        </>
    )
}
export default Products;